import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsNotEmpty,
  IsString,
  IsEnum,
  IsUUID,
  IsOptional,
} from 'class-validator'
import { ResourceType } from '../../../types/resource.types'

/**
 * DTO léger pour une ressource (id, url, type uniquement)
 */
export class ResourceLightDto {
  @ApiProperty({
    description: 'ID de la ressource',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty({ message: "L'ID de la ressource est requis" })
  @IsUUID('4', { message: "L'ID doit être un UUID valide" })
  id!: string

  @ApiProperty({
    description: 'Titre de la ressource',
    example: 'Mathématiques - Chapitre 1',
    type: 'string',
  })
  @IsNotEmpty({ message: 'Le titre de la ressource est requis' })
  @IsString()
  title!: string

  @ApiPropertyOptional({
    description: 'Description de la ressource',
    example: 'Ce document contient les bases des mathématiques pour débutants',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'URL de la ressource',
    example: 'documents/math-chapitre1.pdf',
    type: 'string',
  })
  @IsNotEmpty({ message: "L'URL de la ressource est requise" })
  @IsString()
  url!: string

  @ApiProperty({
    description: 'Type de ressource',
    enum: ResourceType,
    example: ResourceType.FILE,
  })
  @IsNotEmpty({ message: 'Le type de ressource est requis' })
  @IsEnum(ResourceType, {
    message: `Le type doit être l'un des suivants: ${Object.values(ResourceType).join(', ')}`,
  })
  type!: ResourceType
}
